<div *ngIf="currentStep === 1" class="dropzone-box dropzone" id="dropFileForm" (dragover)="overrideDefault($event)"
    [class.disabled]="disabled" (dragenter)="overrideDefault($event)" (dragleave)="overrideDefault($event)"
    (drop)="overrideDefault($event);uploadFile($event);">
    <input type="file" hidden name="files[]" #fileInput id="fileInput" (change)="uploadFile($event)"
        [attr.accept]="extensions">
    <div class="dropzone-box__content">
        <div class="dropzone-box__content__image">
            <img class="image" src="assets/draganddrop.png" alt="drag and drop" />
        </div>
        <div class="dropzone-box__content__text">
            {{'device.files.drag-and-drop-file-here' | translate}}
        </div>
    </div>
    <div class="dropzone-box__button-browse">
        <input type="button" nbButton [status]="'control'" [size]="'large'" [appearance]="'outline'"
            class="appearance-outline" value="{{'device.files.browse' | translate}}" (click)="fileInput.click()"
            [attr.accept]="extensions" />
    </div>
</div>

<div *ngIf="currentStep === 2">
    <div class="file-upload-info-box">
        <div class="file-upload-info-box__text">
            {{'device.files.uploading' | translate}}: <span
                class="file-upload-info-box__text--file-name">{{fileName}}</span>
        </div>
        <div>
            <nb-progress-bar [value]="progress" [status]="'primary'" size="medium" [displayValue]="true"
                [attr.current-value]="progress">
            </nb-progress-bar>
        </div>
        <div *ngIf="showCancelUpload" class="file-upload-info-box__button-cancel">
            <button nbButton class="cancel" [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancelUploadFile()" tabindex="-1">
                {{'common.cancel' | translate}}
            </button>
        </div>
    </div>
</div>